import { useCallback } from "react";
import { pilotById, setActiveGlobal } from "../../common/ApiUtils";
import { SET_ACTIVE_URL } from "../../common/constants";
import { activeDispatch } from "../../reduce/actions";
import { ACTIVE_TYPES } from "../utils/flyDayUtils";

/**
 * Custom hook for managing active configuration (glider, pilots, towing plane)
 */
export const useActiveConfiguration = (active, dispatch, onSelectActiveDetail) => {
  const setActive = useCallback(async (type, value) => {
    const newActive = { ...active };
    newActive[type] = value;

    const message = { type: type };
    message[type] = value;

    await setActiveGlobal(SET_ACTIVE_URL, message);
    dispatch(activeDispatch(newActive));
  }, [active, dispatch]);

  const setPilot = useCallback((pilot, currentType) => {
    if (currentType === 'FIRST' || currentType === 'first') {
      setActive('first', pilot);
    } else if (currentType === 'SECOND' || currentType === 'second') {
      setActive('second', pilot);
    } else if (currentType === 'LIFTER' || currentType === 'lifter') {
      setActive('lifter', pilot);
    }
    onSelectActiveDetail();
  }, [setActive, onSelectActiveDetail]);

  const setGlider = useCallback(async (glider) => {
    const updates = { [ACTIVE_TYPES.GLIDER]: glider };

    if (glider?.foreignFlag && glider?.ownerId) {
      const pilot = await pilotById(glider.ownerId);
      updates[ACTIVE_TYPES.FIRST_PILOT] = pilot;
    }

    await Promise.all([
      setActiveGlobal(SET_ACTIVE_URL, { updates }),
      dispatch(activeDispatch({ ...active, ...updates }))
    ]);

    onSelectActiveDetail();
  }, [active, dispatch, onSelectActiveDetail]);

  const setTowingPlane = useCallback((plane) => {
    setActive('towingPlane', plane);
    onSelectActiveDetail();
  }, [setActive, onSelectActiveDetail]);

  const toggleReel = useCallback(() => {
    const newActive = { ...active, reel: !active.reel, type: "reel" };
    setActiveGlobal(SET_ACTIVE_URL, newActive);
    dispatch(activeDispatch(newActive));
  }, [active, dispatch]);

  return {
    setActive,
    setPilot,
    setGlider,
    setTowingPlane,
    toggleReel
  };
};

